import React from 'react'
import useStoreReportDataContext from 'pages/SummaryStoreReportPage/hooks/useStoreReportDataContext'
import { Table, Spin } from 'antd'
import columns from './columns'

const CloseStoreTableReport = () => {
  const { reportData, reportDataLoading } = useStoreReportDataContext()

  return (
    <Spin spinning={reportDataLoading}>
      <div
        style={{ fontWeight: 700, fontSize: 18, margin: '10px 0px 10px 0px' }}
      >
        ปิดร้าน
      </div>
      <Table
        rowKey={(record) => `id+${record.id}`}
        dataSource={reportData?.close_store}
        columns={columns()}
        scroll={{ x: 650 }}
        style={{
          maxWidth: '700px',
        }}
        size="small"
        pagination={false}
      />
    </Spin>
  )
}

export default CloseStoreTableReport
